// Represents a recursive translation resource object (can be nested)
type TranslationResource = {
  [key: string]: string | TranslationResource
}

// Defines the overall i18n resource structure: language → namespace → translations
type ResourcesType = {
  [language: string]: {
    [namespace: string]: TranslationResource
  }
}

// Dynamically imports all JSON translation files under ./locales/** and constructs the i18n resources object
export function loadResources(): ResourcesType {
  // Import all JSON files under ./locales/<language>/<namespace>.json eagerly at build time
  const modules = import.meta.glob<{ default: TranslationResource }>("./locales/*/*.json", {
    eager: true,
  })

  const resources: ResourcesType = {}

  for (const path in modules) {
    // Extract language and namespace from the file path using regex
    const [, lng, ns] = path.match(/\.\/locales\/(\w+)\/(\w+)\.json$/) || []
    if (!lng || !ns) continue

    // Ensure the language object exists
    resources[lng] ??= {}

    // Assign the imported translations to the appropriate language and namespace
    if (modules[path] && modules[path].default) {
      resources[lng][ns] = modules[path].default
    }
  }

  return resources
}
